import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import classNames           from 'classnames';
import SummaryWidgetEntity  from '../Fragments/SummaryWidgetEntity';

let Quote =  require('../Managers/Quote');

class FinancialRefereeSummaryWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            areDetailsExpanded: false,
        };
    }

    /**
     * Toggle the state of the full details of each financial referee, and then
     * scroll the user's view to that section.
     *
     * @param target {String} the target ID to scroll to
     * @returns {Promise.<TResult>}
     */
    toggleFinancialRefereeDetails(target) {
        return new Promise((resolve) => {
            resolve(this.setState({ areDetailsExpanded: this.state.areDetailsExpanded === false ? true : false }));
        }).then(() => {
            $('html, body').animate({
                scrollTop: $('#' + target).offset().top - $('header.site-header').height()
            }, 1000);
        });
    }

    forceFinancialRefereeDetails(e) {
        e.preventDefault();
        this.setState({ areDetailsExpanded: true });
    }

    /**
     * Reverse lookup for financial referee type enum
     *
     * @param e {Int}
     * @returns {*}
     */
    getFinancialRefereeType(e) {
        switch (e) {
            case 1:
                return 'Accountant';
            case 2:
                return 'Employer';
            case 3:
                return 'Pension administrator';
            case 4:
                return 'Pension statement';
            case 5:
                return 'Self-assessment Tax Return';
            case 6:
                return 'First year Tax Return not submitted';
        }
    }

    getEmploymentStatus(e) {
        if (this.props.financialRefereeNumber === 1) {
            switch (e) {
                case 1:
                    return 'Employed';
                case 2:
                    return 'Self employed';
                case 3:
                    return 'Student';
                case 4:
                    return 'Retired';
                case 6:
                    return 'Independent means';
                case 7:
                    return 'Unemployed';
            }
        }
    }

    render() {
        // Set up classNames for the widget
        let widgetClasses = classNames({
            'summary-widget': true,
            'expanded': this.state.areDetailsExpanded,
        });

        // Set the data
        let fr = this.props.financialRefereeObject;

        // More human-friendly referee numbering
        let numberAsString = ['','First','Second','Third'];

        // @NOTE ben amended chunk to run off base individual application
        let chunk = 'BaseIndividualApplication.financialReferees.' + (this.props.financialRefereeNumber - 1);
        let num = this.props.financialRefereeNumber;

        return(
            <div id={'financialReferee_' + this.props.financialRefereeNumber} className={widgetClasses}>
                <section className="pod">
                    <header className="header">
                        <h3>{numberAsString[this.props.financialRefereeNumber]} financial referee</h3>
                    </header>
                    <div className="content">
                        {this.props.financialRefereeNumber === 1 ?
                            <h4>Employment status: {this.getEmploymentStatus(parseInt(Quote.get('employmentStatus', 'BaseIndividualApplication')))}</h4>
                        :
                            <h4>Type: {this.getFinancialRefereeType(fr.financialRefereeType)}</h4>
                        }

                        {fr.companyName ?
                            <SummaryWidgetEntity
                                fieldName={'companyName' + num}
                                localStorageChunk={chunk}
                                localStorageKey="companyName"
                                fieldType={'text'}
                                label="Company"
                                callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                            />
                        : null}

                        {fr.address ?
                            <div className="summary-widget-row">
                                <strong>Address: </strong>
                                <span>
                                    {fr.address.houseName ? fr.address.houseName + ', ' : null}
                                    {fr.address.street && this.state.areDetailsExpanded ? fr.address.street + ', ' : null}
                                    {fr.address.town && this.state.areDetailsExpanded ? fr.address.town + ', ' : null}
                                    {fr.address.postcode ? fr.address.postcode : null}
                                </span>
                            </div>
                        : null}

                        {fr.applicantAnnualIncome ?
                            <SummaryWidgetEntity
                                fieldName={'applicantAnnualIncome' + num}
                                localStorageChunk={chunk}
                                localStorageKey="applicantAnnualIncome"
                                fieldType={'money'}
                                label="Annual income"
                                labelPrefix={'£'}
                                callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                            />
                        : null}

                        {this.state.areDetailsExpanded ?
                            <div>
                                {fr.startDate ?
                                    <SummaryWidgetEntity
                                        fieldName={'startDate' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="startDate"
                                        fieldType={'date'}
                                        subType={'full'}
                                        label="Start date"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}

                                {fr.contactName ?
                                    <SummaryWidgetEntity
                                        fieldName={'contactName' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="contactName"
                                        fieldType={'text'}
                                        label="Contact"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}

                                {fr.contactPosition ?
                                    <SummaryWidgetEntity
                                        fieldName={'contactPosition' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="contactPosition"
                                        fieldType={'text'}
                                        label="Position"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}

                                {fr.job_title ?
                                    <SummaryWidgetEntity
                                        fieldName={'job_title' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="job_title"
                                        fieldType={'text'}
                                        label="Job title"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}

                                {fr.email ?
                                    <SummaryWidgetEntity
                                        fieldName={'email' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="email"
                                        fieldType={'email'}
                                        label="Email"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}

                                {fr.payrollNumber ?
                                    <SummaryWidgetEntity
                                        fieldName={'payrollNumber' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="payrollNumber"
                                        fieldType={'text'}
                                        label="Payroll/employee number"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}

                                {fr.nationalInsuranceNumber ?
                                    <SummaryWidgetEntity
                                        fieldName={'nationalInsuranceNumber' + num}
                                        localStorageChunk={chunk}
                                        localStorageKey="nationalInsuranceNumber"
                                        fieldType={'text'}
                                        label="National Insurance Number"
                                        callbackFunction={this.forceFinancialRefereeDetails.bind(this)}
                                    />
                                : null}
                            </div>
                        :null}
                    </div>
                    <footer className="footer">
                        {this.state.areDetailsExpanded === false ?
                            <a href="#" className="primary-colour"
                               onClick={this.toggleFinancialRefereeDetails.bind(this, 'financialReferee_' + this.props.financialRefereeNumber)}>View all
                                details</a>
                            :
                            <a href="#" className="primary-colour"
                               onClick={this.toggleFinancialRefereeDetails.bind(this, 'financialReferee_' + this.props.financialRefereeNumber)}>Hide
                                details</a>
                        }
                    </footer>
                </section>
            </div>
        );
    }
}

FinancialRefereeSummaryWidget.propTypes = {
    financialRefereeObject: PropTypes.object.isRequired,
    financialRefereeNumber: PropTypes.number.isRequired,
};

export default FinancialRefereeSummaryWidget;


// WEBPACK FOOTER //
// ./src/components/Fragments/FinancialRefereeSummaryWidget.js